import { render } from "./index.vue?vue&type=template&id=f0d266fc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=f0d266fc&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0d266fc"],['__file',"src/views/room/roomType/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f0d266fc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f0d266fc', __exports__)) {
    console.log('reload')
    api.reload('f0d266fc', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=f0d266fc&scoped=true", () => {
    console.log('re-render')
    api.rerender('f0d266fc', render)
  })

}


export default __exports__